module.exports = __webpack_public_path__ + "img/20241117_gkae.a0e962f5.png";